import { useEffect, useState } from "react";
import Aside from "../../components/Aside";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import { OPTIONS_ACCOUNTS } from "../../constants";
import { ConfigurationService } from "../../services/ConfigurationService";

import SubaccountsPartial from "./subaccounts/SubaccountsPartial";
import FormsPartial from "./forms/FormsPartial";
import TicketsAssignmentsPartial from "./tickets-assignments/TicketsAssignmentsPartial";
import AgentStatusPartial from "./agent-status/AgentStatusPartial";
import AgentPermitsPartial from "./agent-permits/AgentPermitsPartial";
import TemplatesPartial from "./templates/TemplatesPartial";
import AutomaticResponsesPartial from "./automatic-responses/AutomaticResponsesPartial";
import OfficeHoursPartial from "./office-hours/OfficeHoursPartial";
import { useCurrentAccount } from "../../hooks/useCurrentAccount";
import { useTranslation } from "react-i18next";
import FollowUpPartial from "./follow-up/FollowUpPartial";
import BlacklistWordsPartial from "./blacklist-words/BlacklistWordsPartial";

export default function ConfigurationPage() {

    const {t}= useTranslation();

    const [optionConfiguration, setOptionConfiguration] = useState(OPTIONS_ACCOUNTS.SUBACCOUNTS);
    
    const { account } = useCurrentAccount();

    const [information, setInformation] = useState({});

    const getAllAccount = async() => {
        try {
            const allData ={
                account_id: account.id
            }
            const { data } = await ConfigurationService.getAllInfoAccount(allData);
            setInformation(data);

        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        getAllAccount();
    }, []);

    return (
        <>
            <Header />
            <Aside />

            <main id="content" role="main" className="main">

                <div className="content container-fluid">

                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-sm mb-2 mb-sm-0">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb breadcrumb-no-gutter">
                                        <li className="breadcrumb-item "><span className="breadcrumb-link" >{t("config.platform-title")}</span></li>
                                        <li className="breadcrumb-item active" aria-current="page">{t("config.account-title")}</li>
                                    </ol>
                                </nav>
                                <h1 className="page-header-title"><i className="bi-gear nav-icon"></i> {t("config.account-title")} </h1>
                            </div>


                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-3">
                            <div className="navbar-expand-lg navbar-vertical mb-3 mb-lg-5"  >

                                <div className="d-grid">
                                    <button type="button" className="navbar-toggler btn btn-white mb-3" data-bs-toggle="collapse" data-bs-target="#navbarVerticalNavMenuCardTabs" aria-label="Toggle navigation" aria-expanded="false" aria-controls="navbarVerticalNavMenuCardTabs">
                                        <span className="d-flex justify-content-between align-items-center">
                                            <span className="text-dark">Menu</span>

                                            <span className="navbar-toggler-default">
                                                <i className="bi-list"></i>
                                            </span>

                                            <span className="navbar-toggler-toggled">
                                                <i className="bi-x"></i>
                                            </span>
                                        </span>
                                    </button>
                                </div>

                                <div id="navbarVerticalNavMenuCardTabs" className="collapse navbar-collapse">
                                    <div id="navbarSettingsCardWithNavTab" className="card card-navbar-nav nav nav-tabs nav-vertical">
                                        <button 
                                            className={`nav-link py-3 ${optionConfiguration === OPTIONS_ACCOUNTS.SUBACCOUNTS && 'active'}`} 
                                            onClick={() => setOptionConfiguration(OPTIONS_ACCOUNTS.SUBACCOUNTS)}
                                        >
                                            {t("config.subaccount.sub-title")}
                                        </button>
                                        <button className={`nav-link py-3 ${optionConfiguration === OPTIONS_ACCOUNTS.FORMS && 'active'}`} 
                                            onClick={() => setOptionConfiguration(OPTIONS_ACCOUNTS.FORMS)} >
                                            {t("config.forms.form-title")}
                                        </button>
                                        <button className={`nav-link py-3 ${optionConfiguration === OPTIONS_ACCOUNTS.TICKETS && 'active'}`} 
                                            onClick={() => setOptionConfiguration(OPTIONS_ACCOUNTS.TICKETS)} >
                                            {t("config.tickets-assignment.tickets-title")}
                                        </button>
                                        <button className={`nav-link py-3 ${optionConfiguration === OPTIONS_ACCOUNTS.TEMPLATES && 'active'}`} 
                                            onClick={() => setOptionConfiguration(OPTIONS_ACCOUNTS.TEMPLATES)} >
                                            {t("config.templates.templates-title")} 
                                        </button>
                                        {/* <button className={`nav-link py-3 ${optionConfiguration === OPTIONS_ACCOUNTS.ALERTS && 'active'}`} 
                                            onClick={() => setOptionConfiguration(OPTIONS_ACCOUNTS.ALERTS)} >
                                            Alertas
                                        </button> */}
                                        <button className={`nav-link py-3 ${optionConfiguration === OPTIONS_ACCOUNTS.STATUS && 'active'}`} 
                                            onClick={() => setOptionConfiguration(OPTIONS_ACCOUNTS.STATUS)} >
                                            {t("config.status-agent.status-title")}
                                        </button>
                                        <button className={`nav-link py-3 ${optionConfiguration === OPTIONS_ACCOUNTS.SCHEDULES && 'active'}`} 
                                            onClick={() => setOptionConfiguration(OPTIONS_ACCOUNTS.SCHEDULES)} >
                                            {t("config.operation-hours.operation-title")}
                                        </button>
                                        <button className={`nav-link py-3 ${optionConfiguration === OPTIONS_ACCOUNTS.MESSAGES && 'active'}`}
                                            onClick={() => setOptionConfiguration(OPTIONS_ACCOUNTS.MESSAGES)} >
                                            {t("config.automatic-responses.automatic-title")}
                                        </button>
                                        <button className={`nav-link py-3 ${optionConfiguration === OPTIONS_ACCOUNTS.PERMISSIONS && 'active'}`} 
                                            onClick={() => setOptionConfiguration(OPTIONS_ACCOUNTS.PERMISSIONS)} >
                                            {t("config.agent-permissions.agent-title")}
                                        </button>
                                        <button className={`nav-link py-3 ${optionConfiguration === OPTIONS_ACCOUNTS.FOLLOWUP && 'active'}`}
                                        onClick={()=> setOptionConfiguration(OPTIONS_ACCOUNTS.FOLLOWUP)}>
                                           {t('config.tracking.tracking-title')}
                                        </button>
                                        <button className={`nav-link py-3 ${optionConfiguration === OPTIONS_ACCOUNTS.BLACKLIST && 'active'}`}
                                        onClick={()=> setOptionConfiguration(OPTIONS_ACCOUNTS.BLACKLIST)}>
                                           {t('config.blacklist.blacklist-title')}
                                        </button>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="col-lg-9">
                            <div className="row mb-5">
                                <div className="col-12">
                                    { optionConfiguration === OPTIONS_ACCOUNTS.SUBACCOUNTS && <SubaccountsPartial  /> }
                                    
                                    { optionConfiguration === OPTIONS_ACCOUNTS.FORMS && <FormsPartial  /> }
                                    
                                    { optionConfiguration === OPTIONS_ACCOUNTS.TICKETS && <TicketsAssignmentsPartial  /> }
                                    
                                    { optionConfiguration === OPTIONS_ACCOUNTS.STATUS && <AgentStatusPartial  /> }
                                    
                                    { optionConfiguration === OPTIONS_ACCOUNTS.PERMISSIONS && <AgentPermitsPartial  /> }
                                    
                                    { optionConfiguration === OPTIONS_ACCOUNTS.TEMPLATES && <TemplatesPartial  /> }

                                    { optionConfiguration === OPTIONS_ACCOUNTS.MESSAGES && <AutomaticResponsesPartial  /> }
                                    
                                    { optionConfiguration === OPTIONS_ACCOUNTS.SCHEDULES && <OfficeHoursPartial  /> }

                                    { optionConfiguration === OPTIONS_ACCOUNTS.FOLLOWUP && <FollowUpPartial /> }
                                    
                                    { optionConfiguration === OPTIONS_ACCOUNTS.BLACKLIST && <BlacklistWordsPartial /> }
                                </div>
                            </div>
                            
                        </div>
                    </div>

                </div>
                <Footer  />
            </main>


        </>
    )
}